import { DialogComponent } from '@theme/dialog';

/**
 * A dismissible site-wide notice dialog, shown automatically once per
 * browser session (tracked via sessionStorage) and never again until the
 * tab/browser session ends. Reuses the theme's native dialog primitives
 * (DialogComponent) so backdrop click, Escape key, and animations all work
 * exactly like every other dialog in the theme.
 *
 * @extends DialogComponent
 */
export class SiteNoticeDialog extends DialogComponent {
  static STORAGE_KEY = 'waumio:site-notice-dismissed';

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('dialog:close', this.#handleClose);

    if (window.sessionStorage.getItem(SiteNoticeDialog.STORAGE_KEY)) return;

    this.showDialog();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('dialog:close', this.#handleClose);
  }

  #handleClose = () => {
    window.sessionStorage.setItem(SiteNoticeDialog.STORAGE_KEY, '1');
  };
}

if (!customElements.get('site-notice-dialog')) {
  customElements.define('site-notice-dialog', SiteNoticeDialog);
}
